import React, { Component } from "react";
import {
  Box,
  Grid, Tab, Tabs,
  Typography
} from "@mui/material";
import {
  withStyles
} from "@mui/styles";
import {
  HeadElement,
  SearchInput,
  ItemSettingLevel,
  ShopFloorEfficiency
} from "./components";
import {
  VisibleContent
} from "../../../components";
import agent from "../../../agent/agent";
import moment from "moment";
import "moment/locale/ru";

const initFilter = {
  year: "",
  month: "",
  search: "",
  type: "mechanic",

  page: 1,
  limit: 20,
};

class AdministratorStatistics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      totals: {},
      filter: {...initFilter},
      totalPages: 1,
      isLoading: true
    };
  }

  componentDidMount = async () => {
    await this.getItems();
  }

  formatPeriod = (periodString) => {
    if (!periodString) return "";
    const mDate = moment(periodString, "YYYY-MM");
    const formatted = mDate.locale("ru").format("MMMM YYYY");
    return formatted.charAt(0).toUpperCase() + formatted.slice(1) + " год";
  }
  getItems = async () => {
    await this.setState({isLoading: true});
    const filter = this.getFilter();
    const response = await agent.get(`/mechanic-statistics/summary?${ filter }`)
      .then((res) => res?.data).catch(() => null);
    this.setState({
      isLoading: false,
      totals: response?.totals,
      items: response?.items || [],
      totalPages: response?.pagination?.last_page || 1,
      period: this.formatPeriod(response?.period),
    });
  }

  getFilter = () => {
    let _filterStr = [];
    const filter = this.state.filter;
    Object.keys(filter).forEach(key => {
      const _Val = filter[key];
      if (_Val) {
        _filterStr.push(`${key}=${_Val}`);
      }
    })
    return _filterStr.join('&')
  }
  resetFilter = async () => {
    await this.setState({filter: {...initFilter}, isLoading: true});
    await this.getItems();
  }
  changeFilter = async (filter, isFastStart) => {
    await this.setState({filter});
    if (!isFastStart) {
      return
    }
    await this.getItems();
  }

  render() {
    const {
      items,
      filter,
      period,
      totals,
      isLoading,
      totalPages,
    } = this.state;
    const {
      classes,
      userRole,
    } = this.props;

    return (
      <>
        <HeadElement title={['admin'].includes(userRole) ? 'Администратор' : 'Консультант'}/>
        <VisibleContent visible={['admin'].includes(userRole)}>
          <Box mt={2}/>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <ItemSettingLevel title="ДЛЯ Механика" type="mechanic"/>
            </Grid>
            <Grid item xs={6}>
              <ItemSettingLevel title="ДЛЯ Диагноста" type="diagnost"/>
            </Grid>
          </Grid>
        </VisibleContent>
        <Box mt={2}/>
        <Box sx={{background: "#fff", borderRadius: "20px", padding: "20px 30px", boxSizing: "border-box"}}>
          <Typography className={classes.title}>Эффективность цеха</Typography>
          <Tabs value={filter.type} className={classes.tabs} onChange={(e, type) => this.changeFilter({...filter, page: 1, type}, true)}>
            <Tab label="Механики" value="mechanic"/>
            <Tab label="Диагносты" value="diagnost"/>
          </Tabs>
          <Box mt={2}/>
          <SearchInput filter={filter} onChange={this.changeFilter} onReset={this.resetFilter}/>
          <Box mt={2}/>
          <ShopFloorEfficiency
            items={items}
            filter={filter}
            period={period}
            totals={totals}
            isLoading={isLoading}
            totalPages={totalPages}
            onChangFilter={this.changeFilter}
          />
        </Box>
      </>
    );
  }
}

const styles = {
  title: {
    marginBottom: 10,
    fontSize: 24,
    fontWeight: 700,
    color: "#434146",
    lineHeight: "29px",
    letterSpacing: "0.03em",
  },
  tabs: {
    borderBottom: "1px solid #F3F3F3",
    minHeight: 40,
    marginBottom: 20,

    "& .MuiTabs-flexContainer": {
      gap: "20px"
    },
    "& .MuiButtonBase-root": {
      padding: "0px",
      minWidth: 0,
      height: 40,
      minHeight: 40,
      textTransform: "none",
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiTabs-indicator": {
      width: "40px!important"
    }
  }
};
AdministratorStatistics = withStyles(styles)(AdministratorStatistics);

export default AdministratorStatistics
